import { Popover, styled, Typography } from "@mui/material";
import React, { useRef, useState } from "react";

interface HighlightedNameProps {
  name: string;
  description: string;
}

export function HighlightedName({ name, description }: HighlightedNameProps) {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const closeTimeout = useRef<ReturnType<typeof setTimeout>>();

  const handleOpen = (event: React.MouseEvent<HTMLElement>) => {
    clearTimeout(closeTimeout.current);
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    closeTimeout.current = setTimeout(() => setAnchorEl(null), 100);
  };

  const handleCancelClose = () => {
    clearTimeout(closeTimeout.current);
  };

  return (
    <>
      <StyledName onMouseEnter={handleOpen} onMouseLeave={handleClose}>
        {name}
      </StyledName>
      <Popover
        sx={{ pointerEvents: "none" }}
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
        onClose={handleClose}
        disableRestoreFocus
        PaperProps={{
          onMouseEnter: handleCancelClose,
          onMouseLeave: handleClose,
          sx: {
            pointerEvents: "auto",
            maxWidth: 420,
            maxHeight: 320,
            overflowY: "auto",
            p: 1.5,
          },
        }}
      >
        <Typography variant="body2" sx={{ whiteSpace: "pre-line" }}>
          {description}
        </Typography>
      </Popover>
    </>
  );
}

const StyledName = styled("span")(({ theme }) => ({
  color: theme.palette.primary.main,
  textDecoration: "underline",
  textDecorationStyle: "dotted",
  textUnderlineOffset: "2px",
  cursor: "help",
  "@media print": {
    color: "inherit",
    textDecoration: "none",
  },
}));
